export default class PageLoader {
    constructor(pages) {
        this.pages = pages;
    }

    load() {
        _.each(this.pages, page => {
            let newPage = new page();
        });
    }
}


// WEBPACK FOOTER //
// ./javascript/utils/PageLoader.js